jQuery.fn.extend({
    addtocopy: function(usercopytxt) {
        var options = {
            htmlcopytxt: '<br>More: <a href="' + window.location.href + '">' + window.location.href + '</a><br>',
            minlen: 100,
            addcopyfirst: false
        }
        $.extend(options, usercopytxt);
        var copy_sp = document.createElement('span');
        copy_sp.id = 'ctrlcopy';
        copy_sp.innerHTML = options.htmlcopytxt;
        return this.each(function() {
            $(this).mousedown(function() {
                $('#ctrlcopy').remove();
            });
            $(this).mouseup(function(e) {
				copy_sp.innerHTML=options.getText!=undefined ? options.getText(e.target) : options.htmlcopytxt;
                if (window.getSelection) {
                    var slcted = window.getSelection();
                    var seltxt = slcted.toString();
                    if (!seltxt || seltxt.length < options.minlen) return;
                    var nslct = slcted.getRangeAt(0);
                    seltxt = nslct.cloneRange();
                    seltxt.collapse(options.addcopyfirst);
                    seltxt.insertNode(copy_sp);
                    nslct.setEndAfter(copy_sp);
                    slcted.removeAllRanges();
                    slcted.addRange(nslct);
                    if (window.opera) {}
                } else
                if (document.selection) {
                    var slcted = document.selection;
                    var nslct = slcted.createRange();
                    var seltxt = nslct.text;
                    if (!seltxt || seltxt.length < options.minlen) return;
                    seltxt = nslct.duplicate();
                    seltxt.collapse(options.addcopyfirst);
                    seltxt.pasteHTML(copy_sp.outerHTML);
                    if (!options.addcopyfirst) {
                        nslct.setEndPoint("EndToEnd", seltxt);
                        nslct.select();
                    }
                }
            });
        });
    }
});

function show_warn_dlg() {
    var warn_copypast_message = 'При копировании обязательна ссылка на первоисточник: <a href="' + window.location.href + '"  target="_blank">' + window.location.href + '</a>.';
    var dilg_strX = 500;
    if (!$('#show_warn_dlg').length)
        $('body').prepend('<div id="show_warn_dlg_wrapper"></div><span id="show_warn_dlg"></span>');
    $('#show_warn_dlg_wrapper').css({
        background: 'url("/images/overlay.png") left top repeat',
        height: '100%',
        left: '0',
        position: 'fixed',
        top: '0',
        width: '100%',
        display: 'block',
        'z-index': 100000
    });
    var show_warn_dlg = document.getElementById("show_warn_dlg");
    var content = "<div id='warn_dlg_id' onclick='close_warn_dlg();' style='width:" + dilg_strX + "px;'>" + "<div class='title'>Внимание!!!</div>" + "<a class='close' onclick='close_warn_dlg();' href='javascript:void(0)'>?</a>" + "<div style='padding:20px'>" + warn_copypast_message + "</div>"
    show_warn_dlg.innerHTML = content;
    var strY = $(document).scrollTop() + ($(window).height() - ($('#warn_dlg_id').height() + (parseInt($('#warn_dlg_id').css('padding-top')) + parseInt($('#warn_dlg_id').css('padding-bottom'))))) / 2;
    var strX = $(document).scrollLeft() + ($(window).width() - dilg_strX) / 2;
    $('#warn_dlg_id').css({
        'left': strX,
        'top': strY
    });
}

function close_warn_dlg() {
    var warn_dlg_id = document.getElementById("warn_dlg_id");
    warn_dlg_id.style.display = 'none';
    $('#show_warn_dlg_wrapper').hide();
}